/**
 * @class ExtendableError
 *
 * @description this is the error class that all the other error classes should be extended by
 */
class ExtendableError extends Error {
  /**
   *
   * @param message
   * @param payload
   * @param previous
   * @param status
   */
  constructor(message, payload = {}, previous = null, status = null) {
    super(message)
    this.name = this.constructor.name
    this.stack = new Error(message).stack
    this.payload = payload
    this.previous = previous
    this.status = status
  }
}

export default ExtendableError
